import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {AccountManagerService} from "../../services/account-manager-service";
import {environment} from '@environments/environment';
import {SettingsManagerService} from "../../services/settings-manager.service";

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  @Input()
  isExternal: boolean;

  @Input()
  logo: string;

  @Input()
  color: string;

  @Input()
  hideCompanyInfo: boolean;

  @Output()
  onHamburgerClicked = new EventEmitter();

  constructor(
    public accountManagerService: AccountManagerService,
    public settingsManagerService: SettingsManagerService
  ) { }

  ngOnInit(): void {
  }

  downloadConfigurationQR() {
    this.accountManagerService.downloadConfigurationQR();
  }

  get environment() { return environment }

}
